import React from 'react'
import PageAnimation from '@shared/components/page-animation'
import styled from 'styled-components'

const Wrapper = styled.div(({ theme }) => ({
	maxWidth: 800,
	margin: '40px auto',
}))

const Content = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	marginBottom: 80,

	p: {
		marginBottom: theme.spacingsDesktop.m,
		...theme.typography.text18_24,
	},

	h1: {
		...theme.typography.header30_36,
		marginBottom: theme.spacingsDesktop.m,
	},

	h2: {
		marginBottom: theme.spacingsDesktop.m,
		...theme.typography.header28_32,
	},

	h3: {
		marginBottom: theme.spacingsDesktop.s,
		...theme.typography.header24_28,
	},

	'& ul': {
		paddingLeft: 20,
		marginBottom: 16,
	},

	'& li': {
		marginBottom: 8,
	},
}))


export const AppPrivacyPolicy = () => {
	return (
		<PageAnimation>
			<Wrapper>
					<Content>
						<h1>
							ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
							<br /> мобильного приложения «Credit.Club Деньги»
						</h1>

						<h3>Основные термины и сокращения</h3>
						<p style={{ maxWidth: 800 }}>
							<i>Автоматизированная обработка персональных данных</i> - обработка персональных данных с
							помощью средств вычислительной техники.
							<br />
							<i>Блокирование персональных данных</i> - временное прекращение обработки персональных
							данных (за исключением случаев, если обработка персональных данных необходима для
							уточнения персональных данных).
							<br />
							<i>Веб-сайт</i> - совокупность графических и информационных материалов, а также программ
							для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет.
							<br />
							<i>Информационная система персональных данных (ИСПДн)</i> - совокупность содержащихся в
							базах данных персональных данных и обеспечивающих их обработку информационных технологий и
							технических средств.
							<br />
							<i>Мессенджер</i> - службы мгновенных сообщений, программы онлайн-консультанты, и
							программыклиенты (Instant Messenger, IM) для обмена сообщениями в реальном времени через
							Интернет.
							<br />
							<i>Мобильное приложение</i> - программное обеспечение, предназначенное для работы на
							смартфонах, планшетах и других мобильных устройствах, разработанное для конкретной
							платформы (Android, Windows Phone iOS и т. д.).
							<br />
							<i>Обезличивание персональных данных</i> - действия, в результате которых становится
							невозможным без использования дополнительной информации определить принадлежность
							персональных данных к конкретному субъекту персональных данных.
							<br />
							<i>Обработка персональных данных</i> - любое действие (операция) или совокупность действий
							(операций), совершаемых с использованием средств автоматизации или без использования таких
							средств с персональными данными, включая сбор, запись, систематизацию, накопление,
							хранение, уточнение (обновление, изменение), извлечение, использование, передачу
							(распространение, предоставление, доступ), обезличивание, блокирование, удаление,
							уничтожение персональных данных.
							<br />
							<i>Персональные данные (ПДн)</i> - любая информация, относящаяся к прямо или косвенно
							определенному или определяемому физическому лицу (субъекту персональных данных).
							Пользователь - любой посетитель веб-сайтов и мобильного приложения ООО «Credit.Club
							Деньги».
							<br />
							<i>Предоставление персональных данных</i> - действия, направленные на раскрытие
							персональных данных определенному или определяемому физическому лицу (субъекту
							персональных данных).
							<br />
							Распространение персональных данных - действия, направленные на раскрытие персональных
							данных неопределенному кругу лиц.
							<br />
							<i>Роскомнадзор</i> - Федеральная служба по надзору в сфере связи, информационных
							технологий и массовых коммуникаций - уполномоченный орган по защите прав субъектов
							персональных данных.
							<br />
							<i>Уничтожение персональных данных</i> - действия, в результате которых становится
							невозможным восстановить содержание персональных данных в информационной системе
							персональных данных и (или) в результате которых уничтожаются материальные носители
							персональных данных.
							<br />
							<i>Файлы "cookie"</i> - небольшой фрагмент данных, отправленных веб-сервером и хранимый на
							компьютере пользователя.
						</p>

						<h3>1. Правовые основания обработки персональных данных</h3>
						<p style={{ maxWidth: 800 }}>
							1.1. Правовым основанием обработки ПДн является совокупность федеральных законов и
							нормативных правовых актов Российской Федерации, во исполнение которых и в соответствии с
							которыми Оператор осуществляет обработку ПДн, в том числе:
							<br />
							1.1.1. Конституция Российской Федерации;
							<br />
							1.1.2. Гражданский кодекс Российской Федерации;
							<br />
							1.1.3. Трудовой кодекс Российской Федерации;
							<br />
							1.1.4. Налоговый кодекс Российской Федерации;
							<br />
							1.1.5. Федеральный закон от 07.02.2011 N 7-ФЗ "О клиринге и клиринговой деятельности";
							<br />
							1.1.6. Федеральный закон от 06.12.2011 N 167-ФЗ "Об обязательном пенсионном страховании в
							Российской Федерации";
							<br />
							1.1.7. Федеральный закон от 01.04.1996 N 27-ФЗ "Об индивидуальном (персонифицированном)
							учете в системе обязательного пенсионного страхования".
							<br />
							1.1.8. Федеральный закон от 27.07.2006 N 152-ФЗ "О персональных данных".
							<br />
							1.2. Правовым основанием обработки ПДн также являются:
							<br />
							1.2.1. Устав Организации;
							<br />
							1.2.2. договоры, заключаемые между Оператором и субъектами ПДн;
							<br />
							1.2.3. согласие субъектов ПДн на обработку их ПДн.
							<br />
							1.3. ООО "Кредит.Клаб" обрабатывает персональные данные Пользователя только в случае их
							заполнения и (или) отправки Пользователем самостоятельно через специальные формы,
							расположенные в открытых информационных сервисах ООО "Кредит.Клаб", направленные
							посредством электронной почты, сообщениях в мессенджерах. Заполняя соответствующие формы и
							(или) отправляя свои ПДн Оператору персональных данных ООО "Кредит.Клаб", Пользователь
							выражает свое согласие с данной Политикой.
							<br />
							1.4. Оператор ПДн ООО "Кредит.Клаб" обрабатывает обезличенные данные о Пользователе в
							случае, если это разрешено в настройках браузера Пользователя (включено сохранение файлов
							«cookie» и использование технологии JavaScript).
							<br />
							1.5. Субъект персональных данных самостоятельно принимает решение о предоставлении его
							персональных данных и дает согласие свободно, своей волей и в своем интересе.
							<br />
						</p>

						<h3>2. Общие положения</h3>
						<p style={{ maxWidth: 800 }}>
							2.1. Настоящая Политика ООО "Кредит.Клаб" в отношении обработки персональных данных (далее
							- Политика) разработана во исполнение требований Федерального закона от 27.07.2006 N
							152-ФЗ "О персональных данных" (далее - Закон о персональных данных) в целях обеспечения
							защиты прав и свобод человека и гражданина при обработке его персональных данных, в том
							числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.
							<br />
							2.2. Настоящая Политика действует в отношении всех персональных данных, которые
							обрабатывает ООО "Кредит.Клаб" (далее - Оператор/Организация), в том числе к информации,
							которую Оператор может получить о пользователях мобильного приложения «Credit.Club
							Деньги».
							<br />
							2.3. Настоящая Политика распространяется на отношения в области обработки персональных
							данных, возникшие у Оператора как до, так и после утверждения настоящей Политики. <br />
							2.4. Во исполнение требований части 2 статьи 18.1 Закона о персональных данных настоящая
							Политика публикуется в свободном доступе в информационно-телекоммуникационной сети
							Интернет на сайте Оператора по адресу:
							http://public.credit.club/mobilnoe-prilozhenie/privacy_policy.html
							<br />
							2.5. Основные права и обязанности Оператора:
							<br />
							2.5.1. Оператор имеет право:
							<br />
							2.5.1.1. самостоятельно определять состав и перечень мер, необходимых и достаточных для
							обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и
							принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено
							Законом о персональных данных или другими федеральными законами;
							<br />
							2.5.1.2. поручить обработку персональных данных другому лицу с согласия субъекта
							персональных данных, если иное не предусмотрено федеральным законом, на основании
							заключаемого с этим лицом договора. Лицо, осуществляющее обработку персональных данных по
							поручению Оператора, обязано соблюдать принципы и правила обработки персональных данных,
							предусмотренные Законом о персональных данных;
							<br />
							2.5.1.3. в случае отзыва субъектом персональных данных согласия на обработку персональных
							данных Оператор вправе продолжить обработку персональных данных без согласия субъекта
							персональных данных при наличии оснований, указанных в Законе о персональных данных.
							<br />
							2.5.2. Оператор обязан:
							<br />
							2.5.2.1. организовывать обработку персональных данных в соответствии с требованиями Закона
							о персональных данных;
							<br />
							2.5.2.2. отвечать на обращения и запросы субъектов персональных данных и их законных
							представителей в соответствии с требованиями Закона о персональных данных;
							<br />
							2.5.2.3. сообщать в Роскомнадзор по запросу этого органа необходимую информацию в течение
							30 дней с даты получения такого запроса.
							<br />
							2.6. Основные права субъекта персональных данных:
							<br />
							2.6.1. Субъект персональных данных имеет право:
							<br />
							2.6.1.1. получать информацию, касающуюся обработки его персональных данных, за исключением
							случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту
							персональных данных Оператором в доступной форме, и в них не должны содержаться
							персональные данные, относящиеся к другим субъектам персональных данных, за исключением
							случаев, когда имеются законные основания для раскрытия таких персональных данных.
							Перечень информации и порядок ее получения установлен Законом о персональных данных;
							<br />
							2.6.1.2. требовать от Оператора уточнения его персональных данных, или блокирования или
							уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными,
							незаконно полученными или не являются необходимыми для заявленной цели обработки, а также
							принимать предусмотренные Законом о персональных данных меры по защите своих прав;
							<br />
							2.6.1.3. выдвигать условие предварительного согласия при обработке персональных данных в
							целях продвижения на рынке товаров, работ или услуг;
							<br />
							2.6.1.4. обжаловать в Роскомнадзоре или в судебном порядке неправомерные действия или
							бездействие Оператора при обработке его персональных данных.
							<br />
							2.7. Настоящая Политика и сформированные на ее основе положения и инструкции обязательны
							для всех работников ООО "Кредит.Клаб".
							<br />
							2.8. Контроль за исполнением требований настоящей Политики осуществляется уполномоченным
							лицом, ответственным за организацию обработки персональных данных у Оператора.
							<br />
							2.9. Служба внутреннего Оператора в рамках проводимых контрольных процедур оценивает
							эффективность системы внутреннего контроля Оператора по обеспечению соблюдения требований
							настоящей Политики, а также утвержденных внутренних нормативных документов Оператора в
							отношении персональных данных.
							<br />
							2.10. Ответственность за нарушение требований законодательства Российской Федерации и
							внутренних нормативных актов Оператора в сфере обработки и защиты персональных данных
							определяется в соответствии с законодательством Российской Федерации.
							<br />
						</p>

						<h3>3. Цели сбора персональных данных</h3>
						<p style={{ maxWidth: 800 }}>
							3.1. Обработка и сбор ПДн ограничивается достижением конкретных, заранее определенных и
							законных целей. Не допускается обработка ПДн, несовместимая с целями сбора ПДн.
							<br />
							3.2. Обработке подлежат только ПДн, которые отвечают целям их обработки.
							<br />
							3.3. Обработка Оператором ПДн осуществляется в следующих целях:
							<br />
							3.3.1. обеспечение соблюдения Конституции Российской Федерации, федеральных законов и иных
							нормативных правовых актов Российской Федерации;
							<br />
							3.3.2. организация учета работников Оператора для обеспечения соблюдения законов и иных
							нормативных правовых актов Российской Федерации, заключение/исполнение обязательств по
							трудовым договорам, пользования различного вида льготами в соответствии с
							законодательством Российской Федерации, а также внутренними нормативными документами
							Оператора;
							<br />
							3.3.3. содействие работниками в трудоустройстве, получении образования и продвижения по
							службе, обеспечение личной безопасности работников, контроль количества и качества
							выполняемой работы, обеспечение сохранности имущества;
							<br />
							3.3.4. получение работниками заработной платы с использованием банковских платежных карт;
							<br />
							3.3.5. подбор кандидатов на замещение вакантных должностей Организации;
							<br />
							3.3.6. организация постановки на индивидуальный (персонифицированный) учет работников в
							системе обязательного пенсионного страхования;
							<br />
							3.3.7. заполнение и передача в органы исполнительной власти и иные уполномоченные
							организации требуемых сведений и форм отчетности;
							<br />
							3.3.8. осуществление гражданско-правовых отношений;
							<br />
							3.3.9. ведение бухгалтерского учета;
							<br />
							3.3.10. формирование справочных материалов для внутреннего информационного обеспечения
							деятельности Организации;
							<br />
							3.3.11. обеспечение пропускного и внутриобъектового режимов на объектах Организации;
							<br />
							3.3.12. иные законные цели.
							<br />
							3.4. Обработка ПДн работников может осуществляться исключительно в целях обеспечения
							соблюдения законов и иных нормативных правовых актов Российской Федерации.
							<br />
							3.5. Целями обработки персональных данных пользователей мобильного приложения «Credit.Club
							Деньги», личного кабинета на сайте https://credit.club, а также любых других открытых
							информационных систем Организации, являются:
							<br />
							– информирование Пользователя посредством отправки электронных писем и (или) сообщений в
							мессенджерах;
							<br />
							– заключение, исполнение и прекращение гражданско-правовых договоров;
							<br />
							– предоставление доступа Пользователю к сервисам, информации и (или) материалам,
							содержащимся на веб-сайтах и в мобильном приложении «Credit.Club Деньги».
							<br />
							3.6. Оператор имеет право направлять Пользователю уведомления о новых услугах, специальных
							предложениях и различных событиях. Пользователь всегда может отказаться от получения
							информационных сообщений направив письмо на адрес электронной почты platform@credit.club с
							пометкой "Отказ от уведомлений о новых продуктах и услугах и специальных предложениях".
							<br />
						</p>

						<h3>
							4. Объем и категории обрабатываемых персональных данных, категории субъектов персональных
							данных
						</h3>
						<p style={{ maxWidth: 800 }}>
							4.1. Содержание и объем обрабатываемых ПДн должны соответствовать заявленным целям
							обработки, предусмотренными в разделе 4 настоящей Политики. Обрабатываемые ПДн не должны
							быть избыточными по отношению к заявленным целям их обработки.
							<br />
							4.2. Оператор осуществляет обработку ПДн следующих категория субъектов ПДн:
							<br />
							4.2.1. физические лица, являющиеся кандидатами на замещение вакантных должностей в
							Организации;
							<br />
							4.2.2. физические лица, являющиеся работниками и бывшими работниками Организации;
							<br />
							4.2.3. физические лица, являющиеся близкими родственниками работников Организации;
							<br />
							4.2.4. физические лица, осуществляющие выполнение работ по оказанию услуг и заключившие с
							Организацией договор гражданско-правового характера;
							<br />
							4.2.5. физические лица, заключившие или намеревающиеся заключить с Организацией договорные
							отношения в связи с осуществлением Организацией административно-хозяйственной деятельности
							при условии, что их персональные данные включены в информационные системы Организации и
							обрабатываются в соответствии с Законом о персональных данных;
							<br />
							4.2.6. клиенты Организации (индивидуальные предприниматели и физические лица, занимающиеся
							в установленном законодательством Российской Федерации порядке частной практикой);
							<br />
							4.2.7. контрагенты Организации (физические лица и индивидуальные предприниматели);
							<br />
							4.2.8. представители (работники) клиентов и контрагентов Организации - юридических лиц;
							<br />
							4.2.9. бенефициарные владельцы и выгодоприобретатели клиентов Организации;
							<br />
							4.2.10. посетители официального сайта Организации в телекоммуникационной сети Интернет.
							<br />
							4.3. Также происходит сбор и обработка обезличенных данных о посетителях официального
							веб-сайта (в том числе файлов "cookie") с помощью сервисов интернет-статистики.
							<br />
							4.4. Сведения, которые характеризуют физиологические и биологические особенности человека,
							на основании которых можно установить его личность (биометрические ПДн) и которые
							используются Оператором для установления личности субъекта ПДн, могут обрабатываться
							только при наличии согласия субъекта ПДн в письменной форме.
							<br />
							4.5. Оператором не осуществляется обработка специальных категорий ПДн, касающихся расовой,
							национальной принадлежности, политических взглядов, религиозных или философских убеждений,
							состояния здоровья, интимной жизни, за исключением случаев предусмотренных
							законодательством Российской Федерации.
							<br />
						</p>

						<h3>5. Порядок и условия обработки персональных данных</h3>
						<p style={{ maxWidth: 800 }}>
							5.1. Обработка ПДн осуществляется Оператором в соответствии с требованиями
							законодательства Российской Федерации.
							<br />
							5.2. Обработка ПДн осуществляется с согласия субъектов ПДн на обработку их ПДн, а также
							без такового в случаях, предусмотренных законодательством Российской Федерации.
							<br />
							5.3. Субъект ПДн принимает решение о представлении его ПДн и дает согласие на их обработку
							свободно, своей волей и в своем интересе. Согласие на обработку ПДн должно быть
							конкретным, информированных и сознательным. Согласие на обработку ПДн может быть дано
							субъектом ПДн или его представителем в любой позволяющей подтвердить факт его получения
							форме, если иное не установлено федеральным законом.
							<br />
							5.4. Его предоставление ПДн является обязательным в соответствии с федеральным законом,
							Оператор разъясняет субъекту ПДн юридические последствия отказа предоставить его ПДн.
							<br />
							5.5. Третьи лица могут передавать Оператору ПДн субъектов ПДн только в случае, если
							субъект заранее проинформирован ими об обработке Оператором его ПДн и при условии наличия
							у них согласия субъекта ПДн на обработку Оператором его ПДн, если иное специально не
							оговорено с Оператором. По требования Оператора такие лица обязаны представить Оператору
							доказательства информирования субъектов ПДн и наличия указанных согласий.
							<br />
							5.6. Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку
							ПДн.
							<br />
							5.7. К обработке ПДн допускаются работники Оператора, в должностные обязанности которых
							входит обработка ПДн.
							<br />
							5.8. Обработка ПДн осуществляется путем:
							<br />
							5.8.1. получения ПДн в устной и письменной форме непосредственно от субъектов ПДн;
							<br />
							5.8.2. получения ПДн из общедоступных источников;
							<br />
							5.8.3. внесения ПДн в журналы, реестры и информационные системы Оператора.
							<br />
							5.9. Не допускается раскрытие третьим лицам и распространение ПДн без согласия субъекта
							ПДн, если иное не предусмотрено федеральным законом.
							<br />
							5.10. Передача ПДн органам дознания и следствия, в Федеральную налоговую службу,
							Пенсионный фонд Российской Федерации, Фонд социального страхования и другие уполномоченные
							органы исполнительной власти и организации осуществляется в соответствии с требованиями
							законодательства Российской Федерации.
							<br />
							5.11. Оператор принимает необходимые правовые, организационные и технические меры для
							защиты ПДн от неправомерного или случайного доступа к ним, уничтожения, изменения,
							блокирования, распространения и других несанкционированных действий, в том числе:
							<br />
							5.11.1. назначает лицо, ответственное за организацию обработки и защиту персональных
							даных;
							<br />
							5.11.2. определяет угрозы безопасности ПДн при их обработке;
							<br />
							5.11.3. принимает внутренние нормативные и иные документы, регулирующие отношения в сфере
							обработки и защиты ПДн;
							<br />
							5.11.4. обеспечивает ознакомление работников Оператора, непосредственно осуществляющих
							обработку ПДн, с положениями законодательства Российской Федерации о персональных данных,
							в том числе требованиями к защите ПДн;
							<br />
							5.11.5. обеспечивает ознакомление работников Оператора и их представителей под подпись с
							документами Оператора, устанавливающими порядок обработки ПДн работников, а также об их
							правах и обязанностях в этой области;
							<br />
							5.11.6. назначает лиц, ответственных за обеспечение безопасности ПДн в информационных
							системах Оператора;
							<br />
							5.11.7. создает необходимые условия для работы с ПДн;
							<br />
							5.11.8. организует учет документов, содержащих ПДн;
							<br />
							5.11.9. организует работу с информационными системами, в которых обрабатываются ПДн;
							<br />
							5.11.10. хранит ПДн в условиях, при которых обеспечивается их сохранность и исключает
							неправомерный доступ к ним;
							<br />
							5.11.11. организует обучение работников Оператора, осуществляющих обработку ПДн.
							<br />
							5.12. Оператор осуществляет хранение ПДн в форме, позволяющей определить субъекта ПДн, не
							дольше, чем этого требуют цели обработки ПДн, если срок хранения ПДн не установлен
							федеральным законом, договором.
							<br />
							5.13. При сборе ПДн, в том числе посредством информационно-телекоммуникационной сети
							Интернет, Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение
							(обновление, изменение), извлечение ПДн граждан Российской Федерации с использованием баз
							данных, находящихся на территории Российской Федерации, за исключением случаем, указанных
							в Законе о персональных данных.
							<br />
						</p>

						<h3>
							6. Актуализация, исправление, удаление и уничтожение персональных данных, ответы на
							запросы субъектов на доступ к персональным данным
						</h3>
						<p style={{ maxWidth: 800 }}>
							6.1. Подтверждение факта обработки ПДн Оператором, правовые основания и цели обработки
							ПДн, а также иные сведения, указанные в части 7 статьи 14 Закона о персональных данных,
							представляются Оператором субъекту ПДн или его представителю при обращении либо при
							получении запроса субъекта ПДн или его представителя.
							<br />
							В представляемые сведения не включаются ПДн, относящиеся к другим субъектам ПДн, за
							исключением случаев, когда имеются законные основания для раскрытия таких ПДн.
							<br />
							6.2. Запрос субъекта ПДн или его представителя должен содержать:
							<br />
							6.2.1. номер основного документа, удостоверяющего личность субъекта ПДн или его
							представителя, сведения о дате выдачи указанного документа и выдавшем его органе;
							<br />
							6.2.2. сведения, подтверждающие участие субъекта ПДн в отношениях с Оператором (номер
							договора, дата заключения договора, условное словесное обозначение и (или) иные сведения),
							либо сведения, иным образом подтверждающие факт обработки ПДн Оператором;
							<br />
							6.2.3. подпись субъекта ПДн или его представителя.
							<br />
							6.3. Запрос может быть направлен в форме электронного документа и подписан усиленной
							квалифицированной электронной подписью в соответствии с законодательством Российской
							Федерации.
							<br />
							6.4. Если в обращении (запросе) субъекта ПДн или его представителя не отражены в
							соответствии с требованиями Закона о персональных данных все необходимые сведения или
							субъект ПДн не обладает правами доступа к запрашиваемой информации, то ему направляется
							мотивированный отказ.
							<br />
							6.5. Право субъекта ПДн на доступ к его ПДн может быть ограничено в соответствии с частью
							8 статьи 14 Закона о персональных данных, в том числе, если доступ субъекта ПДн к его ПДн
							нарушает права и законные интересы третьих лиц.
							<br />
							6.6. В случае выявления неточных ПДн при обращении субъекта ПДн или его представителя либо
							по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование ПДн,
							относящихся к этому субъекту ПДн, с момента такого обращения или получения указанного
							запроса на период проверки, если блокирование ПДн не нарушает права и законные интересы
							субъекта ПДн или третьих лиц.
							<br />
							6.7. Пользователь может в любой момент отозвать свое согласие на обработку персональных
							данных, актуализацию персональных данных, направив Оператору уведомление посредством
							электронной почты на адрес Оператора platform@credit.club с соответствующей пометкой в
							теме письма (Актуализация персональных данных, отзыв согласия на обработку персональных
							данных).
							<br />
							6.8. Вся информация, которая собирается сторонними сервисами, средствами связи и другими
							поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в
							соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект
							персональных данных и/или Пользователь обязан самостоятельно своевременно ознакомиться с
							указанными документами. Оператор не несет ответственность за действия третьих лиц, в том
							числе указанных в настоящем пункте поставщиков услуг.
							<br />
							6.9. В случае подтверждения факта неточности ПДн Оператор на основании сведений,
							представленных субъектом ПДн или его представителем либо Роскомнадзором, или иных
							необходимых документов уточняет ПДн в течение семи рабочих дней со дня представления таких
							сведений и снимает блокирование ПДн.
							<br />
							6.10. В случае выявления неправомерной обработки ПДн при обращении (запросе) субъекта ПДн
							или его представителя либо Роскомнадзора Оператор осуществляет блокирование неправомерно
							обрабатываемых ПДн, относящихся к этому субъекту ПДн, с момента такого обращения или
							получения запроса.
							<br />
							6.11. При достижении целей обработки ПДн, а также в случае отзыва субъектом ПДн согласия
							на их обработку ПДн подлежат уничтожению, если:
							<br />
							6.11.1. иное не предусмотрено договором, стороной которого, выгодоприобретателем или
							поручителем, по которому является субъект ПДн;
							<br />
							6.11.2. оператор не вправе осуществлять обработку без согласия субъекта ПДн на основаниях,
							предусмотренных Законом о персональных данных или иными федеральными законами;
							<br />
							6.11.3. иное не предусмотрено другим соглашением между Оператором и субъектом ПДн.
							<br />
						</p>

						<h3>7. Сведения о реализуемых требованиях к защите персональных данных</h3>
						<p style={{ maxWidth: 800 }}>
							7.1. Оператор реализует следующие требования законодательства Российской Федерации в
							области ПДн:
							<br />
							7.1.1. требования о соблюдении конфиденциальности ПДн;
							<br />
							7.1.2. требования об обеспечении реализации субъектом ПДн своих прав, включая право на
							доступ к информации;
							<br />
							7.1.3. требования об обеспечении точности ПДн, а в необходимых случаях и актуальности по
							отношению к целям обработки ПДн (с принятием (обеспечением принятия) мер по удалению или
							уточнению неполных или неточных данных);
							<br />
							7.1.4. требования к защите ПДн от неправомерного или случайного доступа к ним,
							уничтожения, изменения, блокирования, копирования, предоставления, распространения ПДн, а
							также от иных неправомерных действий в отношении ПДн;
							<br />
							7.1.5. иные требования законодательства Российской Федерации.
							<br />
							7.2. Оператор самостоятельно определяет состав и перечень мер, необходимых и достаточных
							для обеспечения выполнения обязанностей, предусмотренных законодательством Российской
							Федерации в области ПДн (часть 1 статьи 18.1 Закона о персональных данных).
							<br />
							7.3. В целях исполнения требований законодательства Российской Федерации в области ПДн
							Организацией разработана и применяется настоящая Политика, которая является
							основополагающим локальным правовым актом, определяющим основные направления деятельности
							Организации в области обработки и защиты ПДн.
							<br />
							7.4. Важнейшим условием реализации целей деятельности Организации является обеспечение
							необходимого и достаточного уровня безопасности информационных систем ПДн, соблюдения
							конфиденциальности, целостности и доступности обрабатываемых ПДн и сохранности носителей
							сведений, содержащих ПДн на всех этапах работы с ними.
							<br />
							7.5. Созданные в Организации условия и режим защиты информации, отнесенной к персональным
							данным, позволяют обеспечить защиту обрабатываемых ПДн.
							<br />
							7.6. В Организации в соответствии с требованиями законодательства Российской Федерации
							разработан и введен в действие комплекс организационно-распорядительных и функциональных
							мер, регламентирующих и обеспечивающих безопасность обрабатываемых ПДн:
							<br />
							7.6.1. назначены ответственные лица за организацию и обеспечение безопасности ПДн;
							<br />
							7.6.2. введен режим безопасности обработки и обращения с ПДн, а также режим защиты
							помещений, в которых осуществляется обработка и хранение носителей ПДн;
							<br />
							7.6.3. установлены правила доступа к ПДн, обрабатываемым в информационных системах ПДн;
							<br />
							7.6.4. определен круг лиц, имеющих право обработки ПДн, разработаны инструкции
							пользователям по защите ПДн, антивирусной защите, действиям в кризисных ситуациях;
							<br />
							7.6.5. определены требования к работникам и степень их ответственности за обеспечение
							безопасности ПДн;
							<br />
							7.6.6. проведено ознакомление работников, осуществляющих обработку ПДн, с положениями
							законодательства Российской Федерации по обеспечению безопасности ПДн и требованиями к
							защите ПДн, документами, определяющими политику Организации в отношении обработки ПДн,
							внутренними нормативными документами по вопросам обработки ПДн;
							<br />
							7.6.7. проводится периодическое обучение работников, осуществляющих обработку ПДн,
							правилам обработки ПДн;
							<br />
							7.6.8. осуществляется контроль за соблюдением работниками, допущенных к обработке ПДн,
							требований законодательства Российской Федерации в области ПДн, внутренними нормативными
							актами по вопросам обработки ПДн.
							<br />
							7.7. Организация предпринимает необходимые и достаточные технические меры для обеспечения
							безопасности ПДн от случайного или несанкционированного доступа, уничтожения, изменения,
							блокирования доступа и других несанкционированных действий:
							<br />
							7.7.1. введена система разграничения доступа работников к информации, содержащей ПДн
							субъектов ПДн, в соответствии с их должностными (функциональными) обязанностями;
							<br />
							7.7.2. установлена защита от несанкционированного доступа к автоматизированным рабочим
							местам, информационным сетям и базам ПДн;
							<br />
							7.7.3. установлена защита от вредоносного программно-математического воздействия
							(воздействия на компьютерные системы с помощью вредоносных программ);
							<br />
							7.7.4. осуществляется регулярное резервное копирование информации и баз данных, содержащих
							ПДн субъектов ПДн;
							<br />
							7.7.5. передача информации с использованием информационно телекоммуникационных сетей
							осуществляется при помощи средств криптографической защиты информации;
							<br />
							7.7.6. организована система контроля за порядком обработки ПДн и обеспечения их
							безопасности;
							<br />
							7.7.7. проводятся регулярные проверки соответствия системы защиты ПДн, аудит уровня
							защищенности ПДн в информационных системах ПДн, функционирования средств защиты
							информации, выявления изменений в режиме обработки и защиты ПДн.
							<br />
						</p>

						<h3>8. Заключительные положения</h3>
						<p style={{ maxWidth: 800 }}>
							8.1. Ответственным за внесение изменений в настоящую Политику является старший
							юрисконсульт по сопровождению цифровых сервисов.
							<br />
							8.2. В случае изменения законодательства Российской Федерации, внесения изменений в
							нормативные акты Банка России и иных органов, а также во внутренние нормативные документы
							Организации, до приведения настоящей Политики в соответствие с такими изменениями,
							настоящая Политика действует в части, не противоречащей законодательству Российской
							Федерации и внутренним нормативным документам Организации.
							<br />
							8.3. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся
							обработки его персональных данных, обратившись к Оператору с помощью электронной почты по
							адресу platform@credit.club.
							<br />
							8.4. В данном документе будут отражены любые изменения политики обработки персональных
							данных Оператором. Политика действует бессрочно до замены ее новой версией.
							<br />
							8.5. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу:
							http://public.credit.club/mobilnoe-prilozhenie/privacy_policy.html
							<br />
						</p>
					</Content>
			</Wrapper>
		</PageAnimation>
	)
}

export default AppPrivacyPolicy
